<template>
    <div>
        <div class="t-page" v-show="isSuccess == false">
            <div class="banner">
                <img src="https://resources.holowits.com.sg/HC/97ab7bb899a877918bc2ecbf6efa7adf.jpg" alt="">
                <p style="color: #000000; font-size: 11px;">当注册人数达到上限时，注册通道将关闭。请尽快完成注册。</p>
                <p style="color: #000000; font-size: 11px;">Registration will close when the number of registrants reaches the maximum. Please register as soon as possible.</p>
                <p style="color: #000000; font-size: 11px;">一人仅限注册一次。 感谢您的配合。</p>
                <p style="color: #000000; font-size: 11px;">One registeration for one person. Thank you for your cooperation.</p>
            </div>
            <el-form label-position="top" label-width="80px" :model="form" :rules="rules" ref="form">
                <div class="title first">
                    我们可以通过什么方式联系到您？ How can we reach you?
                </div>
                <el-form-item label="全称 Full Name (Please input English)" prop="fullName">
                    <el-input v-model="form.fullName"></el-input>
                </el-form-item>
                <el-form-item label="职位名称 Job Title">
                    <el-select v-model="form.jobTitle" filterable style="width: 100%;">
                        <el-option label="首席执行官 CEO" value="CEO"></el-option>
                        <el-option label="首席信息官 / 信息技术经理 CIO/IT Manager" value="CIO/IT Manager"></el-option>
                        <el-option label="市场总监 / 经理 Marketing Director/Manager" value="Marketing Director/Manager"></el-option>
                        <el-option label="销售总监 / 经理 Sales Director/Manager" value="Sales Director/Manager"></el-option>
                        <el-option label="技术总监 / 经理 Technical Director/Manager" value="Technical Director/Manager"></el-option>
                        <el-option label="工程 / 技术人员 Engineering/Technical Staff" value="Engineering/Technical Staff"></el-option>
                        <el-option label="其他 Other" value="Other"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="邮箱 Email" prop="email">
                    <el-input v-model="form.email"></el-input>
                </el-form-item>
                <el-form-item label="电话 Telephone">
                    <el-input v-model="form.telephone"></el-input>
                </el-form-item>
                <el-form-item label="WhatsApp账号 Whatsapp ID">
                    <el-input v-model="form.whatsappId"></el-input>
                </el-form-item>
                <div class="title first">
                    公司详情 Company Details
                </div>
                <el-form-item label="公司名称 Company Name" prop="companyName">
                    <el-input v-model="form.companyName"></el-input>
                </el-form-item>
                <el-form-item label="公司类型 Business Type">
                    <el-input v-model="form.businessType"></el-input>
                </el-form-item>
                <el-form-item label="国家 Country" prop="country">
                    <el-input v-model="form.country"></el-input>
                </el-form-item>
                <div class="title first">
                    选择你要参加的商业活动 Choose business activities you will participate in
                </div>
                <el-form-item label="HOLOWITS 2025 秋季新品发布会 HOLOWITS Autumn 2025 New Product Launch" prop="launchEvent">
                    <el-select id="selector1" v-model="form.launchEvent" filterable style="width: 100%;">
                        <el-option label="不参与 Not Participate" value="不参与"></el-option>
                        <el-option label="September 18, 13:30-15:40" value="September 18, 13:30-15:40"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="参观HOLOWITS产品和方案展示活动 Exhibition Session" prop="exhibitionTime">
                    <el-select v-model="form.exhibitionTime" filterable style="width: 100%;">
                        <el-option label="不参与 Not Participate" value="不参与"></el-option>
                        <el-option label="September 18, 09:00-10:00" value="September 18, 09:00-10:00"></el-option>
                        <el-option label="September 18, 10:00-11:00" value="September 18, 10:00-11:00"></el-option>
                        <el-option label="September 18, 11:00-12:00" value="September 18, 11:00-12:00"></el-option>
                        <el-option label="September 18, 12:00-13:00" value="September 18, 12:00-13:00"></el-option>
                        <el-option label="September 18, 13:00-14:00" value="September 18, 13:00-14:00"></el-option>
                        <el-option label="September 18, 14:00-15:00" value="September 18, 14:00-15:00"></el-option>
                        <el-option label="September 18, 15:00-16:00" value="September 18, 15:00-16:00"></el-option>
                        <el-option label="September 18, 16:00-17:00" value="September 18, 16:00-17:00"></el-option>
                        <el-option label="September 18, 17:00-18:00" value="September 18, 17:00-18:00"></el-option>
                        <el-option label="September 19, 09:00-10:00" value="September 19, 09:00-10:00"></el-option>
                        <el-option label="September 19, 10:00-11:00" value="September 19, 10:00-11:00"></el-option>
                        <el-option label="September 19, 11:00-12:00" value="September 19, 11:00-12:00"></el-option>
                        <el-option label="September 19, 12:00-13:00" value="September 19, 12:00-13:00"></el-option>
                        <el-option label="September 19, 13:00-14:00" value="September 19, 13:00-14:00"></el-option>
                        <el-option label="September 19, 14:00-15:00" value="September 19, 14:00-15:00"></el-option>
                        <el-option label="September 19, 15:00-16:00" value="September 19, 15:00-16:00"></el-option>
                        <el-option label="September 19, 16:00-17:00" value="September 19, 16:00-17:00"></el-option>
                        <el-option label="September 19, 17:00-18:00" value="September 19, 17:00-18:00"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <div class="title first">
                        对于未来与 HOLOWITS 的合作，您有任何反馈或建议吗？Do you have any feedback or comments on future cooperation with HOLOWITS?
                    </div>
                    <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 10}" v-model="form.difficulty"></el-input>
                </el-form-item>
                <el-form-item prop="authorization">
                    <el-checkbox v-model="form.authorization">为促进未来的合作并为您提供更优质的服务，HOLOWITS 及其经销商可能会保留您的信息。To promote future cooperation and provide you with better services, HOLOWITS and its distributors may retain your information.</el-checkbox>
                </el-form-item>
            </el-form>

            <!-- <div class="t-input">
                <input class="el-input__inner" v-model="form.industry"/>
                <div :class="['t-label', 'optional', form.industry != ''? 'focus': null]">国家 Country</div>
            </div> -->
 
            <!-- <div class="t-input" :class="{'error': rules.roundtableMeeting}">
                <el-select class="h60" v-model="form.roundtableMeeting" filterable placeholder="Partner Roundtable Meeting" style="width: 100%;" @focus="activity4 = true" @blur="activity4 = false">
                    <el-option label="不参与 Not Participate" value="不参与"></el-option>
                    <el-option label="September 18, 17:00-18:30" value="September 18, 17:00-18:30"></el-option>
                </el-select>
                <div :class="['t-label', form.roundtableMeeting != ''? 'focus': null, activity4 ? 'focus2': null]">合作伙伴圆桌会议（每家公司限 1-2 名 CXO 级别的参会者）Partner Roundtable Meeting (1-2 CXO Level Participants from 1 Company)</div>
            </div> -->
            <!-- <div class="t-input" :class="{'error': rules.banquet}">
                <el-select class="h60" v-model="form.banquet" filterable placeholder="Banquet" style="width: 100%;" @focus="activity5 = true" @blur="activity5 = false">
                    <el-option label="不参与 Not Participate" value="不参与"></el-option>
                    <el-option label="September 18, 18:30-20:30" value="September 18, 18:30-20:30"></el-option>
                </el-select>
                <div :class="['t-label', form.banquet != ''? 'focus': null, activity5 ? 'focus2': null]">晚宴（每家公司限 1-2 名 CXO 级别的参会者）Banquet (1-2 CXO Level Participants from 1 Company)</div>
            </div> -->

            
            <div class="t-input" style="display: flex; justify-content: center;">
                <el-button round style="background-color: #c7000b; color: #ffffff; width: 160px;" :loading="isLoading" @click="add">Submit</el-button>
            </div>
        </div>
        <div v-show="isSuccess === true" style="text-align: center;">
            <img src="https://resources.holowits.com.sg/HC/partner%208.jpg" width="100%" alt="">
        </div>
    </div>
</template>
  
<script>
  import countrys from '@/utils/country.json';
  import {save} from '@/api/otherFormApi';
  export default {
    name: 'ShanghaiInternalIndex',
  data() {
    // 自定义验证函数
    const validateAccept = (rule, value, callback) => {
        // value 是 el-checkbox 的绑定值，应是布尔值
        if (value !== true) { // 严格检查 true
        callback(new Error('require')); // 验证不通过
        } else {
        callback(); // 验证通过
        }
    };
      return {
          isSuccess: false,
          language: 'en',
          activity1: false,
          activity2: false,
          activity3: false,
          activity4: false,
          activity5: false,
          form: {
            fullName: '',
            jobTitle: '',
            email: '',
            telephone: '',
            whatsappId: '',
            companyName: '',
            businessType: '',
            industry: '',
            country: '',
            exhibitionTime: '',
            launchEvent: '',
            difficulty: '',
            authorization: false
          },
          rules: {
            fullName: [{required: true, message: 'required', trigger: 'blur'}],
            companyName: [{required: true, message: 'required', trigger: 'blur'}],
            launchEvent: [{required: true, message: 'required', trigger: 'change'}],
            email: [{required: true, message: 'required', trigger: 'blur'}],
            country: [{required: true, message: 'required', trigger: 'blur'}],
            exhibitionTime: [{required: true, message: 'required', trigger: 'change'}],
            authorization: [{validator: validateAccept, required: true, message: 'required', trigger: 'change'}],
          },
          countryArr: [],
          isLoading: false,
          hasError: false
      }
  },
  created() {
      this.countryArr = countrys.country.map(item => {
          return {label: item, value: item}
      })
  },
//   watch: {
//     form: {
//         handler(n, v) {
//             let checkList = Object.keys(n)
//             for (let key of checkList) {
//                 this.check(key, n[key])
//             }
//         },
//         deep: true
//     }
//   },
  methods: {
    check(key, value) {
        if (key in this.rules) {
            return this.rules[key] = value ? false : true;
        }
    },
     async add() {
        try {
            await this.$refs.form.validate()
            this.form['source'] = 'shanghai-partner-2025'
            this.isLoading = true
            const {data: {data, isSuccess}} = await save({
                content: JSON.stringify(this.form),
                pageSource: 'shanghai-partner-2025'
            })
            if (isSuccess) {
                this.isSuccess = true
                this.isLoading = false
            } else {
                this.isLoading = false
            }
        } catch(e) {
            this.isLoading = false
        }
    }
  }
  }
</script>
  
<style lang="less" scoped>
  .t-page {
    padding-bottom: 30px;
  }
  .banner {
      width: 100%;
      img {
          width: 100%;
      }
  }
  .error-info {
      color: red;
      font-size: 12px;
  }
  .company-icon {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
  
      .left {
          width: 163px;
          height: 80px;
      }
      .line {
          height: 40px;
          width: 2px;
          background-color: #000000;
      }
      .right {
          width: 105px;
          height: 105px;
      }
  }
  .first {
      margin-top: 20px;
  }
  
  .title {
      font-size: 18px;;
      font-weight: 600;
      margin-bottom: 20px;
  }
  .require {
    &::after {
        content: '*';
        padding-left: 2px;
        color: #c7000b;
    }
  }
  /deep/.el-form-item__label {
    font-size: 12px;
    color: #C0C4CC;
    font-weight: 500;
    display: inline-block;
    padding-bottom: 5px;
    line-height: 100%;
  }
  /deep/.el-checkbox__label {
    vertical-align: text-top;
    white-space: normal;
    word-break: break-all;
    width: 90%;
  }
  .t-input {
      margin-bottom: 20px;
      position: relative;
  
      .t-label {
          position: absolute;
          font-size: 14px;
          top: 10px;
          left: 16px;
          background-color: #ffffff;
          color: #C0C4CC;
          transition: all 0.4s;
  
          &::after {
              content: '*';
              padding-left: 2px;
              color: #c7000b;
          }
      }
      .optional {
          &::after {
              content: '';
          }
      }
      .focus {
          padding: 0 5px;
          top: -12px;
          font-size: 12px;
      }
      .focus2 {
          padding: 0 5px;
          top: -12px;
          left: 12px;
          font-size: 12px;
      }
      .el-input__inner:focus+.t-label {
          padding: 0 5px;
          top: -12px;
          font-size: 12px;
      }
  }
  .error {
   ::v-deep input {
        border-color: rgb(199, 0, 11) !important;
    }
    span {
        color: #c7000b;
    }
  }
  @media only screen and (min-width: 992px) {
      .t-page {
          max-width: 838px;
          margin: 20px auto;
      }
  }
  @media only screen and (max-width: 991px) {
      .t-page {
          width: 100%;
          margin: 20px auto;
          padding: 15px;
      }
      ::v-deep .h60 {
            .el-input__inner {
                height: 70px;
            }
      }
      .t-label {
          right: 25px;
      }
      .h60 + .t-label {
          top: 2px;
          bottom: 2px;
      }
  }
</style>